interface AdminRuntimeLaunchState {
    active: boolean;
    handlingReturn: boolean;
    progress: number;
}

export function useAdminRuntimeLaunch(): AdminRuntimeLaunchState {
    return {
        active: false,
        handlingReturn: false,
        progress: 8,
    };
}
